/*
 La forma di un indirizzo email, la stessa per ogni campo che la controlla da sé.

 La parte prima della `@` accetta i caratteri che gli indirizzi veri usano: il `+` delle etichette
 (`nome+fornitore@dominio.it`), l'apostrofo dei cognomi (`o'neil@dominio.it`), trattini, punti
 in mezzo. Il backend li accetta, e un controllo più stretto qui rifiuterebbe un indirizzo buono
 prima ancora di chiederlo a lui.

 Per il resto il controllo è rigoroso: una sola `@`, nessuno spazio, un dominio con almeno un
 punto e un suffisso di lettere, niente punti in testa, in coda o doppi. Non si accettano le
 forme esotiche della RFC (parte locale fra virgolette, dominio come indirizzo IP): nessuno le usa
 per un referente o una PEC, e fra virgolette passerebbero anche spazi e una seconda `@`.

 Si controlla il valore così com'è: uno spazio intorno è un errore da mostrare, non da correggere
 in silenzio, perché è il valore che poi viene salvato.
*/
const PARTE_LOCALE = "[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(\\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*";
const DOMINIO = "([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])?\\.)+[A-Za-z]{2,}";
const EMAIL = new RegExp(`^${PARTE_LOCALE}@${DOMINIO}$`);

export function emailValida(valore: string | undefined | null): boolean {
  return EMAIL.test(valore ?? "");
}
